var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11904)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8018 15.4856C14.9823 15.4711 15.1578 15.4172 15.3159 15.3274C15.5031 15.2211 15.6596 15.0681 15.7701 14.8833C15.8806 14.6986 15.9415 14.4885 15.9469 14.2733C15.9523 14.0582 15.9021 13.8452 15.801 13.6552L9.07285 1.15631L9.07236 1.15542C8.96525 0.957395 8.80671 0.791861 8.61332 0.676432C8.41992 0.560996 8.19892 0.5 7.97365 0.5C7.74837 0.5 7.52737 0.560996 7.33397 0.676432C7.14058 0.791861 6.98204 0.957395 6.87493 1.15542L6.87439 1.1564L0.147414 13.6591L0.146271 13.6612C0.0452067 13.8512 -0.00501821 14.0642 0.000395646 14.2793C0.00580954 14.4945 0.0666825 14.7046 0.177194 14.8893C0.287711 15.0741 0.444146 15.2271 0.631397 15.3334C0.818658 15.4397 1.03029 15.4957 1.24567 15.4957H14.7016C14.7359 15.4957 14.7694 15.4922 14.8018 15.4856Z",
    fill: "#DC0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47559 12.4963C6.47559 11.6707 7.14377 10.9965 7.97403 10.9965C8.80428 10.9965 9.47247 11.6707 9.47247 12.4963C9.47247 13.322 8.80428 13.9962 7.97403 13.9962C7.14377 13.9962 6.47559 13.322 6.47559 12.4963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97363 10.4969V4.49854H8.97363V10.4969H6.97363Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorStatus);
export default __webpack_public_path__ + "static/media/errorStatus.f8a38b0ea502a72bd76d70c3d228a5de.svg";
export { ForwardRef as ReactComponent };